export default "__VITE_ASSET__7c4e05ac__"